module.exports = __webpack_public_path__ + "media/images/icons/material/marker-b19ba46eb74616b1b24f1028066bedce.svg";